// Screen-width flags that follow the browser as it is resized or rotated. The
// breakpoints are Bootstrap's: sm 576px, md 768px, lg 992px. Without matchMedia
// (tests, very old browsers) everything reports the widest layout.
const QUERIES = {
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
}

export default {
  data() {
    return { viewport: { sm: true, md: true, lg: true } }
  },

  computed: {
    // Below sm: phones.
    isPhone() {
      return !this.viewport.sm
    },
    // Below lg: phones and tablets, where the sidebar folds away.
    isDesktop() {
      return this.viewport.lg
    },
  },

  created() {
    if (typeof window === 'undefined' || !window.matchMedia) return

    this.viewportWatchers = Object.keys(QUERIES).map((key) => {
      const list = window.matchMedia(QUERIES[key])
      const update = () => this.$set(this.viewport, key, list.matches)
      update()
      if (list.addEventListener) list.addEventListener('change', update)
      else list.addListener(update)
      return { list, update }
    })
  },

  beforeDestroy() {
    ;(this.viewportWatchers || []).forEach(({ list, update }) => {
      if (list.removeEventListener) list.removeEventListener('change', update)
      else list.removeListener(update)
    })
  },
}
